"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataCard = exports.DataType = void 0;
var moment = require("moment");
var React = require("react");
var styled_components_1 = require("styled-components");
var models_1 = require("../../models");
Object.defineProperty(exports, "DataType", { enumerable: true, get: function () { return models_1.CustomFieldDataType; } });
var theme_1 = require("../../theme");
var utils_1 = require("../../utils");
var DataLabel_1 = require("../DataLabel");
var _1 = require("./");
var DataCard = /** @class */ (function (_super) {
    __extends(DataCard, _super);
    function DataCard(props) {
        var _this = _super.call(this, props) || this;
        _this.getViewStyle = function () {
            return _this.props.isInline ? { width: '100%' } : { flex: 1 };
        };
        _this.getEditStyle = function () {
            return _this.props.isInline ? { width: '100%' } : { flex: 1 };
        };
        _this.getDataLabelEditStyle = function () {
            return _this.props.isInline
                ? { marginBottom: '.2rem', marginLeft: '1rem' }
                : undefined;
        };
        _this.getDataLabelViewStyle = function () {
            return _this.props.isInline
                ? { marginBottom: '1.33rem', marginLeft: '1rem', marginTop: '.33rem' }
                : undefined;
        };
        _this.getDataValueViewStyle = function () {
            return _this.props.isInline ? { paddingLeft: '1rem' } : undefined;
        };
        _this.getWrapperMargin = function () {
            return _this.props.isEdit ? '2.5rem' : undefined;
        };
        _this.state = {
            numberOfColumns: props.numberOfColumns || 2,
        };
        return _this;
    }
    DataCard.prototype.componentWillReceiveProps = function (nextProps) {
        var numberOfColumns = nextProps.numberOfColumns;
        if (this.state.numberOfColumns !== numberOfColumns &&
            typeof numberOfColumns === 'number' &&
            numberOfColumns > 0) {
            this.setState({ numberOfColumns: numberOfColumns });
        }
    };
    DataCard.prototype.convertValuesToRows = function () {
        var values = this.props.values.slice(0);
        var numberOfColumns = this.state.numberOfColumns;
        var rows = [];
        while (values.length) {
            var row = values.splice(0, numberOfColumns);
            if (numberOfColumns - row.length > 0) {
                row.push(new Array(numberOfColumns - row.length).map(function (i) { return React.createElement(React.Fragment, null, "\u00A0"); }));
            }
            rows.push(row);
        }
        return rows;
    };
    DataCard.prototype.getColumnValue = function (column) {
        var dataType = column.dataType, value = column.value;
        if (!value) {
            return null;
        }
        if (!Array.isArray(value) && value.trim().length === 0) {
            return null;
        }
        switch (dataType) {
            case models_1.CustomFieldDataType.Text:
            case models_1.CustomFieldDataType.Number:
                return value.trim();
            case models_1.CustomFieldDataType.Date:
                return moment(value).format('L');
            case models_1.CustomFieldDataType['Date/Time']:
                return moment(value).format('L LT');
            case models_1.CustomFieldDataType['True/False']:
                return value === 'true' ? 'Yes' : value === 'false' ? 'No' : null;
            case models_1.CustomFieldDataType['Pick List']:
                if (Array.isArray(value)) {
                    return value.join(', ');
                }
                else {
                    return value;
                }
            case models_1.CustomFieldDataType.Hyperlink:
                return (React.createElement("a", { href: value.startsWith('http') ? value.trim() : "//" + value.trim(), target: "_blank" }, "View"));
            default:
                return null;
        }
    };
    DataCard.prototype.getViewColumn = function (column) {
        return (React.createElement("div", { style: this.getViewStyle() },
            React.createElement(DataLabel_1.DataLabel, { style: this.getDataLabelViewStyle() }, column.fieldLabel || column.fieldName),
            React.createElement(DataValue, { style: this.getDataValueViewStyle() }, this.getColumnValue(column) || '--')));
    };
    DataCard.prototype.getEditColumn = function (column) {
        var _a = this.props, addUndefinedOption = _a.addUndefinedOption, onInputChanged = _a.onInputChanged;
        return (React.createElement("div", { style: this.getEditStyle() },
            React.createElement(DataLabel_1.DataLabel, { style: this.getDataLabelEditStyle() }, column.fieldLabel || column.fieldName),
            React.createElement("div", null,
                React.createElement(_1.DataCardInput, { addUndefinedOption: addUndefinedOption, isInline: this.props.isInline || false, onInputChanged: onInputChanged, value: column }))));
    };
    DataCard.prototype.renderRows = function () {
        var _this = this;
        var _a = this.props, entityId = _a.entityId, entityName = _a.entityName, isEdit = _a.isEdit, isInline = _a.isInline, style = _a.style;
        var flexDirection = isInline ? 'row' : undefined;
        var justifyContent = isInline ? 'flex-start' : 'space-around';
        var columnWidth = isInline ? '50%' : '100%';
        var marginLeft = isInline ? undefined : '.5rem';
        var rows = this.convertValuesToRows();
        return rows.map(function (row, i) { return (React.createElement("div", { key: "DataCardRow-" + entityName + "-" + (entityId || 'new') + "-" + i, style: __assign(__assign({ display: 'flex', justifyContent: justifyContent, flexDirection: flexDirection }, (i > 0 ? { marginTop: '1rem' } : {})), style === null || style === void 0 ? void 0 : style.row) }, row.map(function (column, r) { return (React.createElement("div", { key: "DataCardColumn-" + entityName + "-" + (entityId || 'new') + "-" + i + "-" + r, style: __assign({ display: 'flex', flexDirection: 'column', width: columnWidth, marginLeft: marginLeft }, style === null || style === void 0 ? void 0 : style.column) }, Array.isArray(column) ? (column) : (React.createElement(React.Fragment, null, isEdit
            ? _this.getEditColumn(column)
            : _this.getViewColumn(column))))); }))); });
    };
    DataCard.prototype.getCardHeadingStyle = function () {
        return !this.props.isEdit
            ? {
                marginBottom: '1rem',
                paddingLeft: '1rem',
            }
            : {
                paddingLeft: '1rem',
            };
    };
    DataCard.prototype.render = function () {
        var _a = this.props, error = _a.error, heading = _a.heading, isInline = _a.isInline, _b = _a.style, style = _b === void 0 ? {} : _b;
        return (React.createElement(React.Fragment, null, isInline ? (React.createElement("div", { style: { marginRight: this.getWrapperMargin() } },
            React.createElement(CardHeading, { style: this.getCardHeadingStyle() }, heading),
            React.createElement("div", { style: __assign({ display: 'flex', flexDirection: 'column' }, style.flexContainer) },
                this.renderRows(),
                error && (React.createElement(ErrorMessage, { style: style.error }, error))))) : (React.createElement(CardWrapper, { style: style.wrapper },
            React.createElement(CardHeading, { style: style.header }, heading),
            React.createElement("div", { style: __assign({ display: 'flex', flexDirection: 'column' }, style.flexContainer) },
                this.renderRows(),
                error && (React.createElement(ErrorMessage, { style: style.error }, error)))))));
    };
    return DataCard;
}(React.Component));
exports.DataCard = DataCard;
var CardWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 0.33rem;\n  margin-bottom: 2rem;\n  padding: 2rem;\n\n  ", "\n"], ["\n  background: ", ";\n  border-radius: 0.33rem;\n  margin-bottom: 2rem;\n  padding: 2rem;\n\n  ",
    "\n"])), theme_1.colors.white, utils_1.mediaScreen({
    device: utils_1.Device.Tablet,
    style: {
        padding: '1rem',
        marginBottom: '1rem',
    },
}));
var CardHeading = styled_components_1.default.h6(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: bold;\n  margin-bottom: 2rem;\n  margin-top: 0;\n\n  ", "\n"], ["\n  font-weight: bold;\n  margin-bottom: 2rem;\n  margin-top: 0;\n\n  ",
    "\n"])), utils_1.mediaScreen({
    device: utils_1.Device.Tablet,
    style: {
        marginBottom: '1rem',
    },
}));
var DataValue = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 1.1667rem;\n  font-weight: bold;\n"], ["\n  font-size: 1.1667rem;\n  font-weight: bold;\n"])));
var ErrorMessage = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: left;\n  font-size: ", ";\n  color: ", ";\n  font-weight: 300;\n  margin-top: 1rem;\n"], ["\n  text-align: left;\n  font-size: ", ";\n  color: ", ";\n  font-weight: 300;\n  margin-top: 1rem;\n"])), theme_1.fontSize.body, theme_1.colors.error);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=DataCard.js.map